import { useMemo } from 'react'

import { Option } from '@joor/design-system'

import { BrandStartOrderIds } from 'modals/OrderList/StartOrderModal/StartOrderModal.ids'

import { getDesignSystemOptionId } from '../../BrandStartOrderModal.formatters'
import messages from '../../BrandStartOrderModal.messages'
import { StyledDropdown } from './EventDropdown.styles'

interface EventDropdownProps {
  options: Option[]
  value: string | null | undefined
  setSelectedOrderEventId: (orderEventId: string) => void
}

export const EventDropdown = ({
  options,
  value,
  setSelectedOrderEventId,
}: EventDropdownProps) => {
  const selectedOption = useMemo(
    () =>
      options.find((option) => getDesignSystemOptionId(option) === value) ??
      null,
    [options, value],
  )

  const handleSelect = ({ selected }: { selected: Option }) => {
    setSelectedOrderEventId(getDesignSystemOptionId(selected))
  }

  return (
    <StyledDropdown
      id={BrandStartOrderIds.EventOptions}
      testId={BrandStartOrderIds.EventOptions}
      labelId={BrandStartOrderIds.EventTitle}
      label={messages.selectEvent}
      options={options}
      value={selectedOption}
      translateOptions={false}
      onSelect={handleSelect}
      placeholder={messages.selectOne}
      isSearchable
    />
  )
}
